/* SAEGE 02/11/26: material line on product pages.
 *
 * Only loads on products with a custom.material metafield, printed into
 * window.SAEGE_PDP_MATERIAL by snippets/saege-pdp-loader.liquid. To roll out to
 * another product, fill in that metafield. No variants or options are changed.
 * The metafield holds the material only; "Finish: " is added here, in PREFIX.
 * Leave it blank on resin bangles: they keep their image swatches and "Colour:" label.
 *
 *  - Product already has a colour swatch row (gold and silver pairs): its "Colour:" label
 *    becomes the material and the row is respaced. The selected swatch keeps its black
 *    ring, because there it shows which option is being viewed.
 *  - No swatch row: a label and one non-clickable swatch are added above the options,
 *    using the same classes as the real swatch row. It has no --active class, so it
 *    takes the plain hairline: with one option there is nothing to select between.
 *    The swatch is silver when the material mentions silver or steel, otherwise gold.
 *
 * SPACING matches the Pear Cut Ring size selector, measured 02/11/26: price to text 20.4px,
 * text to selected option 16.5px, selected option to Add to Bag 24px, text line-height
 * 16.8px. The price block already carries 16px below it, hence 4.4px above the text.
 * Swatch rings sit outside the box (1.5px selected, 1px hairline), so the margins below
 * are those gaps plus the ring.
 *
 * ALIGNMENT: the left margin puts the ring's outer edge on the text edge.
 */
(function () {
  'use strict';

  var M = window.SAEGE_PDP_MATERIAL;
  if (!M) return;

  var PREFIX = 'Finish: ';
  var GOLD = '#e8cc8b';
  var SILVER = '#d2d2d2';

  function visible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function set(el, prop, value) {
    el.style.setProperty(prop, value, 'important');
  }

  function run() {
    var label = document.querySelector('.saege-pdp-swatch-label');
    if (label) {
      var wrap = label.parentElement;
      var dots = wrap.querySelector('.saege-pdp-swatch-dots');
      label.textContent = PREFIX + M;
      set(label, 'line-height', '16.8px');
      set(label, 'margin', '4.4px 0 18px');
      set(wrap, 'gap', '0');
      set(wrap, 'margin-bottom', '25.5px');
      if (dots) set(dots, 'margin-left', '1.5px');
      return true;
    }
    var col = document.querySelector('.saege-ordered');
    var buy = document.querySelector('.saege-ordered .buy-buttons-row');
    if (!col || !buy) return false;

    var anchor = null;
    var rows = col.querySelectorAll(':scope > .input-row');
    for (var i = 0; i < rows.length; i++) {
      if (visible(rows[i])) { anchor = rows[i]; break; }
    }
    if (!anchor) {
      anchor = buy;
      while (anchor && anchor.parentElement !== col) anchor = anchor.parentElement;
    }
    if (!anchor) return false;

    var text = document.createElement('span');
    text.className = 'saege-pdp-swatch-label';
    set(text, 'line-height', '16.8px');
    set(text, 'margin', '4.4px 0 17.5px');
    text.textContent = PREFIX + M;

    var row = document.createElement('div');
    row.className = 'saege-colour-swatches saege-colour-swatches--pdp';
    set(row, 'margin-bottom', '25px');
    var dot = document.createElement('span');
    dot.className = 'saege-colour-swatch saege-colour-swatch--lg';
    dot.style.backgroundColor = /silver|steel/i.test(M) ? SILVER : GOLD;
    dot.style.cursor = 'default';
    set(dot, 'margin-left', '1px');
    dot.setAttribute('aria-hidden', 'true');
    row.appendChild(dot);

    col.insertBefore(text, anchor);
    col.insertBefore(row, anchor);
    return true;
  }

  function start() {
    if (run()) return;
    var n = 0;
    var iv = setInterval(function () {
      if (run() || ++n > 160) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
